import React  from 'react';
import {MediaType} from '../../../data/media';

const PreviewFaceButton = ({ravenUuid, mqttService}) => {
    const request = {
        mediaType: MediaType.MEDIA_PREVIEW_FACE
    };
    const previewFaceRequest = () => mqttService.sendMediaRequest({ ravenUuid, request });

    return (
        <button
            onClick={previewFaceRequest}
            className="btn btn-blue btn-sm"
            title='Send Face Detect Request over MQTT (debug)'>
            <i className="material-icons">person</i> Preview Face Request
        </button>
    );
}

export default PreviewFaceButton;
